import React from 'react'
import Container from 'semantic-ui-react/dist/commonjs/elements/Container'

export default ({ inline, children }) =>
  inline ? <React.Fragment children={children} /> : <Container children={children} />
